/**
 * Types + constants for the theme system.
 *
 * Source: docs/theme/06-dark-mode.md + 04-spacing-radius-elevation.md
 */

/** User's stored preference. */
export type ThemePreference = 'light' | 'dark' | 'system';

/** What's actually applied to the <html> element after resolution. */
export type ResolvedTheme = 'light' | 'dark';

/** UI density (theme T4 §2). CAs + advocates prefer compact; founders prefer regular. */
export type Density = 'regular' | 'compact';

/** localStorage keys. Keep in sync with the FOUC script in layout.tsx. */
export const STORAGE_KEY_THEME: string = 'theme';
export const STORAGE_KEY_DENSITY: string = 'density';

/**
 * Minimal shape of the white-label config the frontend consumes.
 *
 * Source: docs/registered-users/users-me.json (org.white_label).
 */
export interface WhiteLabelConfig {
  is_active: boolean;
  logo_url: string | null;
  logo_dark_url: string | null;
  favicon_url: string | null;
  display_name: string | null;
  /** CDN URL of the per-org theme.css produced by the backend (T7b §3). */
  theme_css_url: string | null;
}
